import { cfg } from "../../configuracion";

export const postTokenCliente = async () => {
  let respuesta = {
    datos: null,
    error: null,
  };
  try {
    const url = cfg.apiUrl + "/auth/login";

    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Accept-Language": "es",


        // Deshabilitar provisionalmente la caché
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Pragma": "no-cache",
        "Expires": "0"
      },
      body: encodeURIComponent("cliente") +
          "=" +
          encodeURIComponent(cfg.apiCliente)
    });

    if (resp.status === 200) {
      let datos = await resp.json();
      if (datos?.codigo !== "200") {
        respuesta = {
          ...datos,
          error: datos?.mensaje || "Error: Unknown",
        };
      } else {
        respuesta = { ...datos };
      }
    } else {
      const errorData = await resp.json();
      respuesta = {
        ...respuesta,
        error: errorData.error || "Error: " + resp.status,
      };
    }
  } catch (error) {
    respuesta = { ...respuesta, error: error.mensaje };
  }
  if (respuesta?.datos) {
    return respuesta.datos.authToken;
  }
  return respuesta;
};
